export const companyInstrumentTabs = [
  { value: 'rating-news', label: 'Rating News' },
  { value: 'research', label: 'Research' },
];

export const companyEntityTabs = [
  { value: 'instruments', label: 'Instruments' },
  ...companyInstrumentTabs,
];
